module.exports = __webpack_public_path__ + "img/home-bg4.d9f66a30.png";